import { api } from './http-client';
import { BookingAdmin, BookingDetail, BookingsParams } from '../interfaces/booking.interface';
import { PageDto } from '../types/pagination';

export const bookingsService = {
  getBookings: async (params: BookingsParams): Promise<PageDto<BookingAdmin>> => {
    const response = await api.request<PageDto<BookingAdmin>>({
      url: '/admin/bookings',
      method: 'GET',
      params,
    });
    return response.data;
  },

  getBooking: async (id: string): Promise<BookingDetail> => {
    const response = await api.request<BookingDetail>({
      url: `/admin/bookings/${id}`,
      method: 'GET',
    });
    return response.data;
  },
};
